/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import CopyButton from './CopyButton';
import DateRangePicker from './DateRangePicker';
import EllipsisText, {
  buildCopyIcons,
  buildTypographyCopyable,
  type CopyIconPosition,
  TYPOGRAPHY_COPY_TOOLTIPS,
} from './EllipsisText';
import ExportButton from './ExportButton';
import Footer from './Footer';
import HeaderTitle from './HeaderTitle';
import ObjectUpload, {
  getMinioUrl,
  getObjectFileUrl,
  getObjectUploadFileId,
  objectUploadNormFile,
} from './ObjectUpload';
import PreviewImage from './PreviewImage';
import { Question, NotificationBell } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import ThemeAlert from './ThemeAlert';

export {
  AvatarDropdown,
  AvatarName,
  buildCopyIcons,
  buildTypographyCopyable,
  CopyButton,
  type CopyIconPosition,
  DateRangePicker,
  EllipsisText,
  ExportButton,
  Footer,
  getMinioUrl,
  getObjectFileUrl,
  getObjectUploadFileId,
  HeaderTitle,
  ObjectUpload,
  objectUploadNormFile,
  NotificationBell,
  PreviewImage,
  Question,
  ThemeAlert,
  TYPOGRAPHY_COPY_TOOLTIPS,
};
